// const PREFIX = process.env.VUE_APP_CODE
const PREFIX = 'CONSOLE-DG-ADMIN-SYSTEM'
// token在cookie中存储的键名
export const cookieTokenKey = PREFIX + '/tempTokenKey'
// 用户信息在cookie中存储的键名
export const cookieUserInfoKey = PREFIX + '/userInfoKey'
// 样式在localStorage中的key
export const themeLocalKey = PREFIX + '/THEME'
export const tagsLocalKey = PREFIX + '/TAGS'
// 应用在localStorage中的key
export const appLocaleKey = PREFIX + '/APP'
